<template>
    <div class="well ovx-auto">
        <div class="flex-level">
            <div class="flex fs-4 bold">
                {{ $l10n.__('Notes de frais') }}
            </div>
            <div class="flex aright">
                <CompassButton
                    :label="$t.__('common.actions.impact_profit')"
                    type="secondary"
                    :disabled="impactButtonIsDisable"
                    @click="impact()"
                />
                <CompassButton
                    :label="$t.__('documents.overview.tab.margin.Expense.link_an_expense')"
                    type="secondary"
                    :disabled="!canImpact"
                    :onclick="`expensesTools.linkTo('${doctype}', ${docid});`"
                />
            </div>
        </div>

        <el-table ref="multipleTable" :data="expenses" @selection-change="handleSelectionChange">
            <el-table-column type="selection" :selectable="canProcess" property="processMargin">
            </el-table-column>
            <el-table-column :label="$t.__('common.labels.impact_profit')">
                <template #default="scope">
                    {{ displaySaasBoolean(scope.row.processMargin) }}
                </template>
            </el-table-column>
            <el-table-column :label="$t.__('common.labels.date')">
                <template #default="scope">
                    {{ $filters.saasDateFormatted(scope.row.date) }}
                </template>
            </el-table-column>
            <el-table-column
                property="supplier"
                :label="$t.__('documents.overview.tab.margin.supplier')"
            >
            </el-table-column>
            <el-table-column property="ident" :label="$t.__('common.labels.reference')">
            </el-table-column>
            <el-table-column
                property="formatted_totalAmount"
                :label="$t.__('documents.overview.tab.margin.purchase_amount_exclude_tax')"
            >
            </el-table-column>
            <el-table-column v-if="canImpact" fixed="right">
                <template #default="scope">
                    <a class="link mr-2" @click="removeLink(scope.row, context)">
                        {{ $l10n.__('Délier') }}
                    </a>
                </template>
            </el-table-column>
        </el-table>

        <div v-if="expenses.length > 0" class="aright fs-3 mt-2">
            {{ $filters.numberFormatCurrency($l10n.__('Total impact') }} : {{ formattedTotal) }}
        </div>
    </div>
</template>

<script>
import MarginMixins from './MarginMixins.js';
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('documentOverview');

export default {
    mixins: [MarginMixins],
    data: function () {
        return {
            context: 'expense',
        };
    },
    computed: {
        ...mapState({
            expenses: (state) => state.expenses,
            original: (state) => state.expenses.filter((link) => link.processMargin === true),
        }),
    },
};
</script>
